import { render, staticRenderFns } from "./CreateRecord.vue?vue&type=template&id=0f15bfb6&scoped=true"
import script from "./CreateRecord.vue?vue&type=script&lang=js"
export * from "./CreateRecord.vue?vue&type=script&lang=js"
import style0 from "./CreateRecord.vue?vue&type=style&index=0&id=0f15bfb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15bfb6",
  null
  
)

export default component.exports